<div
  class="timeline-container"
  [ngStyle]="{
    'background-color':
      this.data === undefined || this.data.length === 0
        ? noDataRowColor
        : rowColor,
  }">
  <div
    class="header-container"
    (mouseenter)="onContainerMouseEnter()"
    (mouseleave)="onContainerMouseLeave()">
    <span class="timeline-header">
      {{ title }}
    </span>
    <!-- Tooltip that appears only for Operating State -->
    <div
      *ngIf="showTooltip && title === 'Operating State'"
      class="header-tooltip"
      (click)="viewDefinitions()">
      View Definitions
    </div>
  </div>
  <div
    class="timeline-segments"
    [ngClass]="data !== undefined && data.length !== 0 ? '' : 'empty'">
    <div *ngIf="data.length !== 0 && data !== undefined; else noData">
      <div
        *ngFor="let dataElement of data"
        class="timeline-segment"
        [ngClass]="{ 'timeline-dot': dataElement.width === 0 }"
        [ngStyle]="{
          left: dataElement.left + '%',
          width: dataElement.width + '%',
        }"
        [style]="dataElement.styles || ''"
        (mouseout)="onLeaveFromEventTimelineDot()"
        (mouseover)="onHoverOverEventTimelineDot(dataElement, $event)"></div>
      <div
        *ngIf="showHintTooltip"
        class="timeline__hover-bar-tooltip"
        [innerHtml]="hint"
        [ngStyle]="hoverBarTooltipX"></div>
    </div>
  </div>
  <ng-template #noData>
    <div>No Data</div>
  </ng-template>
</div>

<ng-template #definitionsModal>
  <div class="definition-modal draggable-modal">
    <div
      class="definition-modal__header-container"
      id="modalDragHandle">
      <h2 class="definitions-title">Operating State Definitions</h2>
      <div
        class="modal-close-btn"
        type="button"
        (click)="closeModal()">
        <i class="lx-icon lx-close-x"></i>
      </div>
    </div>

    <div class="definition-modal__content">
      <div class="table-container">
        <table class="state-definitions-table">
          <thead>
            <tr>
              <th>State</th>
              <th>Ignition</th>
              <th>Transmitting Data</th>
              <th>Recording</th>
              <th>Livestream</th>
              <th>Trigger</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let state of operatingStateData">
              <td>
                <span
                  class="state-color-chip"
                  [style.background-color]="state.color + '26'"
                  [style.color]="state.color">
                  {{ state.state }}
                </span>
              </td>
              <td>{{ state.ignition }}</td>
              <td>{{ state.transmittingReceivingData }}</td>
              <td>{{ state.recordingDvrVideoEvents }}</td>
              <td>{{ state.livestreamDvr }}</td>
              <td>{{ state.trigger }}</td>
              <td>{{ state.notes }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button
          class="lx-btn lx-btn-secondary close-button"
          (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
